<template>
    <div>
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>{{$t('order_number')}}</th>
                    <th>{{$t('order_price')}}</th>
                    <th>{{$t('dateTitle')}}</th>
                </tr>
                </thead>
                <tbody v-if="userOrders.length > 0">
                <tr v-for="(userOrder,index) in userOrders" :key="index">
                    <td>
                        <a style="color: #0a6ebd" href="#" @click.prevent="changePage(userOrder)">{{userOrder.code}}</a>
                    </td>
                    <td>{{userOrder.price}}</td>
                    <td>{{userOrder.date}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "history",
        props: {
            userOrders: {
                type: Array,
                default: null
            }
        },
        methods:{
            changePage(myItem) {
                window.scrollTo(0, 0);
                this.$router.push({name: 'OrderDetails', params: {'orderid': myItem.id}});
                location.reload();
            },
        }
    }
</script>

<style scoped>

</style>